import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors } from '@lichtblick/theme';
import { Chip, Headline, Text } from '@lichtblick/ui-components';
import { RichText } from '../../../../helpers/RichText';
import { AButton } from '../../../AButton';
import { AImage } from '../../../AImage';
import { StyledIcon, StyledItem } from '../../../AListItem/AListItem.styles';
import { StyledMList } from '../../../MList';
import { ProductCardOptionalRoot } from './MProductCardOptional.styles';
import { ProductInformation } from './shared';
const elementMappers = {
    ul: ({ children })=>/*#__PURE__*/ _jsx(StyledMList, {
            children: children
        }),
    li: ({ children })=>/*#__PURE__*/ _jsxs(StyledItem, {
            children: [
                /*#__PURE__*/ _jsx(StyledIcon, {
                    $color: "light-moss"
                }),
                children
            ]
        })
};
export const MProductCardOptional = ({ backgroundColor, item })=>{
    const itemIsDefined = (item)=>Boolean(item?.component);
    const isDefined = itemIsDefined(item);
    if (!isDefined) {
        return null;
    }
    const { image, sellingPoints, subtitle, textCTA, title } = item;
    return /*#__PURE__*/ _jsxs(ProductCardOptionalRoot, {
        $backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ _jsx(Chip, {
                backgroundColor: Colors.Gray,
                label: "Optional"
            }),
            image && /*#__PURE__*/ _jsx(AImage, {
                ...image?.[0]
            }),
            /*#__PURE__*/ _jsxs(ProductInformation, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        size: "Xs",
                        children: subtitle
                    }),
                    /*#__PURE__*/ _jsx(Headline, {
                        renderAs: "h3",
                        size: "S",
                        children: title
                    }),
                    sellingPoints && /*#__PURE__*/ _jsx(RichText, {
                        elementMappers: elementMappers,
                        richText: sellingPoints
                    }),
                    textCTA?.[0] && /*#__PURE__*/ _jsx(AButton, {
                        ...textCTA?.[0]
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=MProductCardOptional.js.map